import {
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnInit,
    Output,
} from '@angular/core';
import { Observable } from 'rxjs';
import { first } from 'rxjs/operators';

import {
    ColumnConfigItem,
    Icon,
    PersonOfInterest,
} from '../../coaching-insight/oa/models/coaching.global.model';
import { TranslationKeyMap } from '../main-frontline/main-fl.i18n';
import { FLMi2Metric, FLMI2Person } from '../main-frontline/model/flmi2.model';

import { FLMi2Dates } from './model/fl-mi2-dates.model';
import { SortDirection } from './model/sort-direction.model';
import { FrontlineMI2Service } from './services/frontline-mi2.service';
@Component({
    selector: 'cmps-frontline-mi2',
    templateUrl: './frontline-mi2.component.html',
    // host:{'class':'cmps-frontline-oa'}
})
export class FrontlineMi2Component implements OnInit {
    @Input() selectedUser: number;
    @Input() active: string[];
    @Output() metricsRendered: EventEmitter<boolean> =
        new EventEmitter<boolean>();

    @Output() selectedUserChange: EventEmitter<PersonOfInterest> =
        new EventEmitter<PersonOfInterest>();

    public flmi2Data: FLMI2Person;
    public columns: Observable<ColumnConfigItem[]>;
    public FLMi2PeriodDates: FLMi2Dates;
    public metriccolumns: Observable<ColumnConfigItem[]>;
    public i18n = TranslationKeyMap;
    hasPendingData = false;
    tempFlMI2Data: FLMI2Person; // will effectively be the floaData (the Top Level user)

    public activetab = 'tab-performance';
    public activecolumns: Observable<number>;

    barcolours = {
        numeratorColour: 'green',
        denominatorColour: 'red',
    };

    constructor(
        private readonly _el: ElementRef<HTMLElement>,
        private readonly _flmi2Service: FrontlineMI2Service,
    ) {}

    appendSubordinates(
        subordinates?: FLMI2Person[],
        parent?: FLMI2Person,
    ): void {
        parent.subOrdinates = subordinates;
        if (!subordinates) {
            parent.isExpanded = false;
        } else {
            parent.isExpanded = true;
        }

        this.assignParentBack(parent);
    }

    appendMetrics(metrics?: FLMi2Metric[], parent?: FLMI2Person): void {
        parent.metrics = metrics;
        if (!metrics) {
            parent.isExpandedMetrics = false;
        } else {
            parent.isExpandedMetrics = true;
        }

        this.assignParentBack(parent);
    }

    assignParentBack(d: FLMI2Person): void {
        if (this.tempFlMI2Data.userId === d.userId) {
            this.tempFlMI2Data = d;
        } else {
            searchAndReplace(this.tempFlMI2Data, d);
        }
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        function searchAndReplace(o: FLMI2Person, p: FLMI2Person) {
            if (o.userId === p.userId) {
                o = { ...p };
                return o;
            } else {
                if (o.subOrdinates?.length) {
                    for (let x = 0; x < o.subOrdinates.length; x++) {
                        const y = searchAndReplace(o.subOrdinates[x], p);
                        if (y && y.userId === o.subOrdinates[x].userId) {
                            o.subOrdinates[x] = y;
                        }
                    }
                }
            }
        }
        this._flmi2Service.setCurrentFlmi2State(this.tempFlMI2Data);
    }

    getFlMI2Data(level: number, data: any): void {
        const rowData = { ...data };

        if (level !== 1) {
            rowData.maxUncoached = this.flmi2Data.totalDeclining;
            rowData.maxCoached = this.flmi2Data.totalImproving;
        }

        rowData.levelClass = `level${level}`;
        rowData.level = level;

        return rowData;
    }

    ngOnInit(): void {
        this._flmi2Service.initializeColumnConfig();
        this.columns = this._flmi2Service.mi2columns;
        this.columns.pipe(first()).subscribe();
        const a = this._flmi2Service.retrieveFLMi2(this.selectedUser);
        const data = a.subscribe((res) => {
            data.unsubscribe();
            if (res) {
                this.flmi2Data = { ...res };
                this.tempFlMI2Data = { ...this.flmi2Data };
            }
        });

        const _FLMi2Dates = this._flmi2Service.retrieveFLMi2PeriodDates(
            this.selectedUser,
        );
        const _FLMi2DatesSub = _FLMi2Dates.subscribe((res) => {
            _FLMi2DatesSub.unsubscribe();
            if (res) {
                this.FLMi2PeriodDates = { ...res };
            }
        });
    }

    sortTeamByScore(force?: SortDirection): SortDirection {
        return this._flmi2Service.sortTeamBy(
            'oascore',
            force,
            this.tempFlMI2Data,
        );
    }

    sortTeamByExpected(force?: SortDirection): SortDirection {
        return this._flmi2Service.sortTeamBy(
            'expected',
            force,
            this.tempFlMI2Data,
        );
    }

    toggle(event, icon: Icon, columns: ColumnConfigItem[]): void {
        let newstate = null;

        if (icon.action) {
            newstate = this[icon.action](null, icon.actionParams);
        }

        if (icon?.state !== undefined) {
            columns.forEach((g) => {
                if (g.icon) {
                    g.icon.forEach((f) => {
                        if (
                            newstate === SortDirection.DEFAULT &&
                            f.defaultState != null
                        ) {
                            f.counter = f.defaultState;
                        } else {
                            f.counter = SortDirection.DEFAULT;
                        }
                    });
                }
            });
            icon.state = !icon.state;
            icon.counter = newstate;
        }
    }

    checkIfAllCollapsed(): void {
        const floa = this.flmi2Data;

        if (!floa.isExpanded && !floa.subOrdinates) {
            this.sortTeamByExpected(SortDirection.DEFAULT); // sort default
            this.sortTeamByScore(SortDirection.ASC);

            const cols = this._flmi2Service.getColumns();
            // reset all column's sort
            cols.forEach((g) => {
                if (g.icon) {
                    g.icon.forEach((f) => {
                        if (f.defaultState != null) {
                            f.counter = f.defaultState;
                        } else {
                            f.counter = SortDirection.DEFAULT;
                        }
                    });
                }
            });
        }
    }
}
